import MPopover from './Popover.vue';

export default MPopover;
